/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {pushMessages} from '../api'

export const useMutationPushMessages = createReactQueryMutationHook('pushMessages', pushMessages)
